/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen_list': {
    width: 16,
    height: 16,
    viewBox: '0 0 35.55 41',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" _fill="none" _stroke="#383e47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.45 40H1V1h33.55v23.72"/><path pid="1" _fill="none" _stroke="#383e47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.2 8.41h5.7v5.7H7.2zM7.2 20.62h5.7v5.7H7.2zM17.29 9.1h11.23M17.29 13.43h11.23M17.29 21.31h11.23M17.29 25.64h11.23"/><path pid="2" _fill="#df4545" d="M34.6 29.15H23.41V40L34.6 29.15z"/></g></g>'
  }
})
